import React from "react";
import style from "./profileCoverPhoto.module.scss";

export default function ProfileCoverPhoto() {
  return (
    <div className={style["profile-bg"]}>{/* img src background here */}</div>
  );
}
